'use client';
import {observer} from 'mobx-react';
import {useEffect} from 'react';

import Notification from '@/components/Notification';
import type INotification from '@/models/Notifications';
import type NotificationStore from '@/store/NotificationStore';
import GlobalStoresIdentifier from '@/utils/enums/store-identifier';
import {useGlobalStoreContext} from '@/utils/hooks/contextHooks';

function NotificationRenderer({locale}: {locale: string}) {
  const store = useGlobalStoreContext();
  const {notifications, addNotification} = store.getStore<NotificationStore>(GlobalStoresIdentifier.NOTIFICATION_STORE);

  return (
    <div className="fixed right-0 top-10 z-[100] mx-4 flex flex-col gap-5 transition-all duration-1000 ease-in-out">
      {notifications.map((item: INotification) => {
        return <Notification key={item.id} {...item} locale={locale} />;
      })}
    </div>
  );
}

export default observer(NotificationRenderer);
